import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Utilities.frontend.types'

@Injectable({ providedIn: 'root' })
export class Utilities_check_footprint_versionService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { minimumVersion?: string }): Promise<{ productVersion?: string, suggestedMessage?: string, schemaVersion?: string, meetsMinimumVersion?: boolean, logs?: string[] }> 
  {
    let url = `${environment.backendUrl}api/Utilities/functions/check_footprint_version`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

